import { Ref, ref } from 'vue';

interface Notification {
    messageId: string
    message: string
    type: 'ERROR' | 'SUCCESS' | 'WARNING' | 'INFO'
}

interface NotificationInput {
    message: string
    type?: Notification['type']
}

interface NotifyOptions {
    sustain?: boolean
}

const notifications: Ref<Notification[]> = ref([]);

interface NotificationHook {
    notifications: Ref<Notification[]>
    removeNotification: (messageId: string) => void
    notify: (messages: NotificationInput | NotificationInput[], options?: NotifyOptions) => void
}

export const useNotifications = (): NotificationHook => {
    function notify(
        messages: NotificationInput | NotificationInput[],
        { sustain }: NotifyOptions = {}
      ): void {
        // Convert single message to array if necessary
        const messageArray = Array.isArray(messages) ? messages : [messages];
    
        messageArray.forEach(message => {
          const messageText = typeof message === 'string' ? message : message.message;
          const messageType = (typeof message === 'string' ? 'ERROR' : message.type) || 'ERROR';
          const messageId = Math.random().toString();
    
          const duplicateMessage = notifications.value.find(m => m.message === messageText);
    
          if (duplicateMessage) {
            duplicateMessage.messageId = messageId;
          } else {
            notifications.value.push({
              messageId,
              message: messageText,
              type: messageType
            });
          }
    
          if (!sustain) {
            setTimeout(() => {
              removeNotification(messageId);
            }, 5 * 1000);
          }
        });
      }
    
      function removeNotification(messageId: string): void {
        notifications.value = notifications.value.filter(n => n.messageId !== messageId);
      }

    return {
        notify,
        removeNotification,
        notifications
    }
}